var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewPhishing = function SvgNewPhishing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.242 12.93h-5.86a1.17 1.17 0 0 1-1.171-1.172V2.383A1.17 1.17 0 0 1 2.383 1.21h14.062a1.17 1.17 0 0 1 1.172 1.172v6.445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.352 1.64 10.99 6.535a2.584 2.584 0 0 1-3.152 0L1.476 1.641M11.422 16.743v-1.757a1.9 1.9 0 0 1-1.172-1.758 3.719 3.719 0 0 1 7.422 0 1.91 1.91 0 0 1-1.172 1.758v1.757M13.96 15.572v1.171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12.536 13.224a.293.293 0 0 1 0-.586M12.536 13.224a.293.293 0 0 0 0-.586M15.426 13.224a.293.293 0 0 1 0-.586M15.426 13.224a.293.293 0 0 0 0-.586"
  })));
};
export default SvgNewPhishing;